// enci.mainlayout.js
'use strict';

import { debugLog } from '../enci.log.js';
import { initializeThemeRoute as pageLoaderThemeRoute } from '../enci.pageLoader.js'; // Renamed import

class MainLayoutManager {
  async initializeComponent(componentName, isAdmin, headerSelector) {
    debugLog(
      `MainLayoutManager.initializeComponent >> Initializing ${componentName}: isAdmin=${isAdmin}`
    );

    try {
      await this.initializeSection(headerSelector);
      debugLog(
        `MainLayoutManager.initializeComponent >> ${componentName} initialized successfully`
      );
    } catch (error) {
      debugLog(
        `MainLayoutManager.initializeComponent >> Error in ${componentName} initialization: ${error.message}`,
        {
          type: 'error',
        }
      );
      throw error;
    }
  }

  async initializeSection() {
    debugLog(`MainLayoutManager.initializeSection >> Initializing section`);

    try {
      await pageLoaderThemeRoute(); // Using renamed import

      debugLog(`MainLayoutManager.initializeSection >> Section initialized successfully`);
    } catch (error) {
      debugLog(`MainLayoutManager.initializeSection >> Error: ${error.message}`, {
        type: 'error',
      });
      throw error;
    }
  }

  async initializeThemeRoute() {
    debugLog(`MainLayoutManager.initializeThemeRoute >> Initializing theme route`);

    try {
      await pageLoaderThemeRoute(); // Using renamed import
      debugLog(`MainLayoutManager.initializeThemeRoute >> Theme route initialized successfully`);
    } catch (error) {
      debugLog(`MainLayoutManager.initializeThemeRoute >> Error: ${error.message}`, {
        type: 'error',
      });
      throw error;
    }
  }

  async cleanupComponent(componentName) {
    debugLog(`MainLayoutManager.cleanupComponent >> Cleaning up ${componentName}`);

    try {
      // Add cleanup logic here
      debugLog(`MainLayoutManager.cleanupComponent >> ${componentName} cleaned up successfully`);
    } catch (error) {
      debugLog(
        `MainLayoutManager.cleanupComponent >> Error cleaning up ${componentName}: ${error.message}`,
        {
          type: 'error',
        }
      );
      throw error;
    }
  }
}

// Create instance
const mainLayoutManager = new MainLayoutManager();

// Export functions that will be called from C#
export const initializeComponent = async (componentName, isAdmin, headerSelector) =>
  mainLayoutManager.initializeComponent(componentName, isAdmin, headerSelector);
export const cleanupComponent = async componentName =>
  mainLayoutManager.cleanupComponent(componentName);
export const initializeThemeRoute = async () => mainLayoutManager.initializeThemeRoute();

// Export the manager instance
export { mainLayoutManager };
